import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  PointElement,
  LinearScale,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Divider } from "semantic-ui-react";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement);

const LineChart = ({ dateChart, data, title, setChartRun }) => {
  var xxx = 0;

  const labels = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  const data1 = {
    labels: labels,
    datasets: [
      {
        label: "History ",
        pointStyle: "circle",
        pointRadius: 5,
        pointHoverRadius: 15,
        data: data,
        fill: false,
        borderColor: "purple",
        tension: 0.1,
      },
    ],
  };

  var options = {
    scales: {
      y: {
        beginAtZero: true,
        display: true,
      },
      x: {
        display: true,
      },
    },
  };

  return (
    <div>
      <Grid>
        <Box>
          <Typography variant="h6"> {title}</Typography>
        </Box>
        <Box>
          <Line data={data1} options={options} />
        </Box>
      </Grid>
    </div>
  );
};

export default LineChart;
